import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { resolvePath, sso as ssoPath, useQuery } from '../../../routes';
import { fromAccounts, fromSecuritySetting } from '../../../store';

interface ButtonToLicenseManagementProps {
  orgId: number;
}

const ButtonToLicenseManagement = (props: ButtonToLicenseManagementProps) => {
  const { orgId } = props;

  const intl = useIntl();

  const accountId = useQuery().get('accountId');

  const securitySetting = useSelector(
    fromSecuritySetting.selectAllSecuritySettingsByAccountId(Number(accountId)),
  );

  const account = useSelector(fromAccounts.selectAccountById(Number(accountId)));

  const resolveLicenseManagementPath = () => {
    if (isEmpty(securitySetting) || isEmpty(account)) return '';

    const { g3: isFullGen3Account, domain: gen2Domain } = securitySetting[0];

    const gen3Domain = account?.domain;

    if (isFullGen3Account) {
      let finalDomain = gen3Domain ?? gen2Domain;
      if (!finalDomain) {
        finalDomain = `ac-${accountId}`;
      }
      return `https://${finalDomain}.${process.env.REACT_APP_CUSTOM_DOMAIN_POSTFIX}/admin/account/license-management`;
    }

    return resolvePath(ssoPath, undefined, {
      redirect_uri: `${process.env.REACT_APP_ADMIN_URL}/organization/${orgId}/admin/license_keys/kse`,
    });
  };

  return (
    <Button
      id="goto-licence-management-page"
      variant="contained"
      size="large"
      color="primary"
      sx={{
        width: 322,
        color: '#233145',
        ml: 1,
      }}
      onClick={() => window.location.href = resolveLicenseManagementPath()}
    >
      {intl.formatMessage({ id: 'payment_status.button.back_license_management' })}
    </Button>
  );
};

export default ButtonToLicenseManagement;
